export function normalizeCurrencyCode(code) {
    return String(code || '').toUpperCase();
}

export function currencyMeta(currencies, code) {
    const normalized = normalizeCurrencyCode(code);

    return (currencies || []).find(item => item && normalizeCurrencyCode(item.code) === normalized) || null;
}

export function currencySymbol(currencies, code) {
    const normalized = normalizeCurrencyCode(code);
    const currency = currencyMeta(currencies, normalized);

    if (currency && (currency.symbol_native || currency.symbol)) {
        return currency.symbol_native || currency.symbol;
    }

    if (normalized === 'USDT') {
        return '\u20AE';
    }

    return normalized === 'EURC' ? '\u20AC' : '$';
}

export function currencyDecimals(currencies, code, fallback = 2) {
    const currency = currencyMeta(currencies, code);
    const decimals = parseInt(currency && currency.decimal_digits !== undefined ? currency.decimal_digits : fallback, 10);

    return Number.isInteger(decimals) && decimals >= 0 ? decimals : fallback;
}

export function currencyFieldConfig(currencies, code) {
    const config = {
        locale: 'en-US',
        decimalLength: currencyDecimals(currencies, code),
        autoDecimalMode: false,
        min: null,
        max: null,
        defaultValue: null,
        valueAsInteger: false,
        allowNegative: false
    };
    const symbol = currencySymbol(currencies, code);

    if (symbol) {
        config.prefix = symbol + ' ';
    }

    return config;
}

export function parseMoney(value, currencies, code) {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
    }

    if (value === null || value === undefined) {
        return 0;
    }

    const raw = String(value).trim();
    if (!raw) {
        return 0;
    }

    const cleaned = raw.replace(/[^\d,.-]/g, '');
    const separator = decimalSeparatorForAmount(cleaned, currencyDecimals(currencies, code));
    const normalized = separator === ','
        ? cleaned.replace(/\./g, '').replace(',', '.')
        : (separator === '.'
            ? cleaned.replace(/,/g, '')
            : cleaned.replace(/[,.]/g, ''));
    const amount = Number(normalized);

    return Number.isFinite(amount) ? amount : 0;
}

export function decimalSeparatorForAmount(value, decimals) {
    const commaCount = (value.match(/,/g) || []).length;
    const dotCount = (value.match(/\./g) || []).length;

    if (commaCount > 0 && dotCount > 0) {
        return value.lastIndexOf(',') > value.lastIndexOf('.') ? ',' : '.';
    }

    const separator = commaCount > 0 ? ',' : (dotCount > 0 ? '.' : '');
    const count = commaCount || dotCount;

    if (!separator || count > 1 || decimals <= 0) {
        return '';
    }

    const parts = value.split(separator);
    const before = (parts[0] || '').replace(/[^\d]/g, '');
    const after = (parts[1] || '').replace(/[^\d]/g, '');

    if (!after) {
        return '';
    }

    if (after.length === 3 && before.length <= 3) {
        return '';
    }

    if (after.length > decimals) {
        return '';
    }

    return separator;
}
